export default __webpack_public_path__ + "static/media/logo-grey.f89cb444.svg";